module.exports = __webpack_public_path__ + "static/media/CompletedAssessmentImg.17231b05.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/CompletedAssessmentImg.png
// module id = 355
// module chunks = 0